import { KYDEventStatus } from "@common/interfaces/KYDEvent";

/**
 * Get the display text for an event status
 * @param status - The event status
 * @returns The human-readable status text
 */
export const getEventStatusText = (status: KYDEventStatus): string => {
  switch (status) {
    case "OPEN":
      return "Live";
    case "DRAFT":
      return "Draft";
    case "PENDING_APPROVAL":
      return "Pending Approval";
    case "PENDING_ANNOUNCEMENT":
      return "Unannounced";
    case "OFFSALE":
      return "Off Sale";
    case "CANCELED":
      return "Canceled";
    case "ARCHIVED":
      return "Archived";
    default:
      return "Unknown";
  }
};

